@if (
    {
        disabled:
            isDisabled ||
            formElement?.pendingChange?.status ===
                PENDING_CHANGE_STATUS_TYPE.Submitted,
    };
    as context
) {
    @if (isSmartView && !context.disabled) {
        <div class="grid mb-3" [formGroup]="$any(formControl)">
            @if (
                $any(addressTypeService?.addressTypeSchema?.options?.length) > 1
            ) {
                <wdx-form-field
                    class="mb-3 d-block g-col-12 g-col-lg-6"
                    [locked]="addressTypeService.addressTypeSchema?.isLocked"
                    [label]="
                        addressTypeService.addressTypeSchema?.label
                            | translateTokenisedString
                    "
                    [guidanceText]="
                        addressTypeService.addressTypeSchema?.guidanceText
                            | translateTokenisedString
                    "
                    [isSensitive]="
                        addressTypeService.addressTypeSchema?.isSensitive ??
                        undefined
                    "
                    [isRequired]="
                        addressTypeService.addressTypeSchema?.isRequired ??
                        undefined
                    "
                    [labelForId]="'smartAddressAddressType'"
                    [validationErrorMessage]="
                        formControl?.touched
                            ? (formControl?.errors | validationErrorMessage)
                            : ''
                    "
                    [warningMessage]="warningText"
                >
                    <ng-select
                        class="select-options-wrap"
                        bindLabel="label"
                        bindValue="value"
                        [attr.data-cy]="
                            'dropdown-' +
                            addressTypeService.addressTypeSchema?.name
                        "
                        [items]="
                            $any(addressTypeService.addressTypeSchema.options)
                        "
                        [formControlName]="
                            $any(addressTypeService.addressTypeSchema?.name)
                        "
                    ></ng-select>
                </wdx-form-field>
            }
        </div>
        <wdx-form-field
            [locked]="formElement?.isLocked"
            [label]="formElement?.label | translateTokenisedString"
            [guidanceText]="
                formElement?.guidanceText | translateTokenisedString
            "
            [isSensitive]="formElement?.isSensitive ?? undefined"
            [isRequired]="formElement?.isRequired ?? undefined"
            [labelForId]="inputId"
            [validationErrorMessage]="
                formControl?.touched
                    ? (formControl?.errors | validationErrorMessage)
                    : ''
            "
            [warningMessage]="warningText"
            data-cy="ff-smart-address"
        >
            @if (
                !isDisabled ||
                !PENDING_CHANGES_LOCK_FIELD.includes(
                    $any(formElement?.pendingChange?.status)
                )
            ) {
                <button
                    formFieldActionButton
                    type="button"
                    class="ms-2"
                    data-cy="action-smart-input"
                    [wdxButton]="WdxButtonStyle.Link"
                    (click)="onToggleView()"
                >
                    {{
                        TRANSLATION_ADDRESS_CONTROL_MANUAL_INPUT
                            | translateTokenisedString
                    }}
                </button>
            }
            <div class="input-group">
                @if (!addressSelect.hasValue) {
                    <div class="input-group-text">
                        <wdx-icon icon="search"></wdx-icon>
                    </div>
                }
                <ng-select
                    #addressSelect
                    class="flex-grow-1"
                    bindLabel="displayText"
                    bindValue="identifier"
                    typeToSearchText="Search for an address"
                    notFoundText="No Addresses found"
                    data-cy="dropdown-address"
                    [ngModel]="(selectedAddressDisplay$ | ngrxPush)?.identifier"
                    [ngModelOptions]="{ standalone: true }"
                    [typeahead]="addressInput$"
                    [trackByFn]="trackByFn"
                    [loading]="$any(addressSearchResultsIsLoading$ | ngrxPush)"
                    [items]="addressItems$ | ngrxPush"
                    (change)="onLookupSelected($event)"
                ></ng-select>
            </div>
            @if (hasValue$ | ngrxPush) {
                <div
                    class="card card-body d-flex flex-row align-items-center justify-content-between mt-2"
                >
                    <address class="mb-0" data-cy="address-result">
                        @for (
                            addressField of smartAddressFields$ | ngrxPush;
                            track $index
                        ) {
                            <span class="d-block" [innerHtml]="addressField">
                            </span>
                        }
                    </address>
                    @if (!isDisabled) {
                        <button
                            type="button"
                            size="sm"
                            data-cy="btn-clear"
                            (click)="onLookupClear()"
                            [wdxButton]="WdxButtonStyle.Link"
                            [wdxIconButton]="true"
                        >
                            <wdx-icon icon="trash-alt"></wdx-icon>
                        </button>
                    }
                </div>
            }
        </wdx-form-field>
    } @else {
        <wdx-form-field
            [locked]="formElement?.isLocked"
            [label]="formElement?.label | translateTokenisedString"
            [guidanceText]="
                formElement?.guidanceText | translateTokenisedString
            "
            [isSensitive]="formElement?.isSensitive ?? undefined"
            [isRequired]="formElement?.isRequired ?? undefined"
            data-cy="ff-manual-address"
        >
            <div class="d-flex" formFieldActionButton>
                @if (!isDisabled && addressLookupEnabled) {
                    <button
                        type="button"
                        [wdxButton]="WdxButtonStyle.Link"
                        class="ms-2"
                        data-cy="action-manual-input"
                        (click)="onToggleView()"
                    >
                        {{
                            TRANSLATION_ADDRESS_CONTROL_SMART_INPUT
                                | translateTokenisedString
                        }}
                    </button>
                }
            </div>
            @let validatorsEnabled = validatorsEnabled$ | ngrxPush;
            @if (submitted && validatorsEnabled && formControl?.invalid) {
                @if (validationSummary$ | ngrxPush; as validationSummary) {
                    <wdx-ff-validation-summary
                        class="d-block mb-3"
                        message="Address contains missing values or validation errors"
                        [validationSummary]="validationSummary"
                        (errorClicked)="onErrorClicked($event)"
                    ></wdx-ff-validation-summary>
                }
            }
            <ng-container [formGroup]="$any(formControl)">
                <div class="card card-muted pt-3">
                    @if (formElement?.children; as childFormElements) {
                        <div class="card-body grid">
                            @for (
                                childFormElement of childFormElements;
                                track childFormElement.name
                            ) {
                                @if (!childFormElement.isHidden) {
                                    @if ($any(childFormElement).forcesNewRow) {
                                        <div class="g-col-12"></div>
                                    }
                                    <div
                                        class="g-col-12 input form-input mb-3"
                                        [ngClass]="{
                                            'g-col-lg-6':
                                                !$any(childFormElement)
                                                    .forcesFullWidth,
                                        }"
                                        [attr.data-form-control]="
                                            childFormElement.name
                                        "
                                    >
                                        <wdx-ff-controls-mapper
                                            class="h-100 d-block"
                                            [class.validation-disabled]="
                                                !validatorsEnabled
                                            "
                                            [formElement]="
                                                $any(childFormElement)
                                            "
                                            [attr.data-cy]="
                                                'ff-manual-address-' +
                                                childFormElement.name
                                            "
                                        ></wdx-ff-controls-mapper>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            </ng-container>
        </wdx-form-field>
    }
}
